module.exports = __webpack_public_path__ + "img/base.5668ed6a.png";